import { ImageLoaderProps } from 'next/image';

const CACHE_BUST = '12-11-2024';

export function directusImageWrapperLoader({
  src,
  width,
  quality,
}: ImageLoaderProps) {
  const directusAssetsURL = process.env.NEXT_PUBLIC_ASSETS_URL;

  if (!directusAssetsURL || !src.includes(directusAssetsURL)) {
    return src;
  }

  const url = new URL(src);
  const key = url.searchParams.get('key');

  if (key) {
    // preserve original key
    return `${src}&_requested_width=${width}&cache_bust=${CACHE_BUST}`;
  }

  quality = quality || 90;

  if (src.includes('?')) {
    return `${src}&fit=cover&quality=${quality}&withoutEnlargement=true&format=webp&cache_bust=${CACHE_BUST}`;
  }

  return `${src}?fit=cover&quality=${quality}&withoutEnlargement=true&format=webp&cache_bust=${CACHE_BUST}`;
}